import { Box } from "@mui/material";
import { City } from "common/interfaces/City";
import { memo } from "react";
import styles from "../SwitchAreaDialog.module.scss";

export const CitiesSelector = memo(
  (props: {
    selectableCities: {
      area_code: string | undefined;
      area_name: string | undefined;
      pref_code: string;
      pref_name: string;
      city_code: string;
      city_name: string;
    }[];
    selectedCityCodes: string[];
    onCitiesClick: (city: City) => void;
  }) => {
    const { selectableCities, selectedCityCodes, onCitiesClick } = props;

    const selectablePrefectures = Array.from(
      new Set(selectableCities.map((city) => city.pref_code))
    ).sort();

    return selectablePrefectures.map((prefCode) => {
      const prefName = selectableCities.find(
        (x) => x.pref_code === prefCode
      )?.pref_name;

      const areasOfPref = Array.from(
        new Set(
          selectableCities
            .filter((x) => x.pref_code === prefCode)
            .map((x) =>
              JSON.stringify({ area_code: x.area_code, area_name: x.area_name })
            )
        )
      )
        .map((x) => JSON.parse(x) as { area_code?: string; area_name?: string })
        .sort((a, b) => (a.area_code ?? "").localeCompare(b.area_code ?? ""));

      return areasOfPref.map((area, index) => {
        const citiesOfArea = selectableCities
          .filter(
            (x) => x.pref_code === prefCode && x.area_code === area.area_code
          )
          .sort((a, b) => a.city_code.localeCompare(b.city_code));

        return (
          <Box key={prefCode} className={styles.prefBox}>
            {index === 0 ? (
              <Box className={styles.prefName}>{prefName}</Box>
            ) : null}
            {area.area_code && (
              <Box className={styles.areaName}>{area.area_name}</Box>
            )}
            {citiesOfArea.map((city) => (
              <Box
                key={city.city_code}
                className={`${styles.btn_switch01} ${styles.click_act01} ${
                  selectedCityCodes.includes(city.city_code) ? styles.on : ""
                }`}
                onClick={() => onCitiesClick(city)}
              >
                {city.city_name}
              </Box>
            ))}
          </Box>
        );
      });
    });
  }
);
